
import React from "react";
import { Card, Button } from "react-bootstrap";
import "./Cardsand.css"; // Optional: For custom styles

export const Cardsand = ({ product }) => {
  return (
    // <Card style={{ width: '18rem' }}>
    <Card >
       <Card.Img variant="top" src={product.image} style={{height:250}} className="border img-fluid card-img-top" />
      <Card.Body className="text-center">
        <Card.Title>{product.title}</Card.Title>
        <Card.Text>{product.Descripriton}<br></br>{product.price}</Card.Text> 
        <Button className="bg-white btn btn-outline-warning">Add Cart</Button>
      </Card.Body>
    </Card>
  );
};
export default Cardsand;